import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ApolloProvider, ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { FCC } from '../../lib/types';
import LoginPage from '../pages/Home/Login';
import AccessDenied from '../pages/Home/AccessDenied';

const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '';

const AuthContext = createContext('');
const cache = new InMemoryCache();

const Auth: FCC = ({ children }) => {
  const { accounts, instance } = useMsal();
  const [authToken, setAuthToken] = useState('');
  const [userName, setUserName] = useState('');
  const [noAccess, setNoAccess] = useState(false);

  useEffect(() => {
    const tokenRequest = {
      scopes: [`api://${REACT_APP_CLIENT_ID}/Read`],
    };

    const user = accounts[0];

    if (user) {
      instance.acquireTokenSilent(tokenRequest).then((response: any) => {
        // Handle the successful acquisition of a new token
        if (response?.idTokenClaims?.roles) {
          // console.log(response.idToken);
          console.log(response.idTokenClaims?.roles);
        } else {
          console.log('Access Denied');
          setNoAccess(true);
        }
        setAuthToken(response.idToken);
        setUserName(`[${response.account.name || ''}](${response.account.username || ''})`);
      });
    } else {
      instance
        .handleRedirectPromise()
        .then((authResult) => {
          instance.loginRedirect();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [instance, accounts]);

  const client = useMemo(() => {
    const link = createHttpLink({
      uri: process.env.REACT_APP_API_URL || '',
      headers: {
        Authorization: `Bearer ${authToken}`,
        'user-name': userName,
        'Content-Type': 'application/json',
        'apollo-require-preflight': 'true',
      },
    });
    return new ApolloClient({ cache, link });
  }, [userName, authToken]);

  return (
    <>
      {authToken && !noAccess && (
        <AuthenticatedTemplate>
          <AuthContext.Provider value={authToken}>
            <ApolloProvider client={client}>{children}</ApolloProvider>
          </AuthContext.Provider>
        </AuthenticatedTemplate>
      )}
      {!authToken && !noAccess && <LoginPage />}
      {noAccess && <AccessDenied />}
    </>
  );
};

export default Auth;

// TODO: Delete this later after direct connection with EKG is established on the backend server
export const AizeClientProvider: FCC = ({ children }) => {
  const authToken = useContext(AuthContext);
  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPH_API_URL!,
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'https://companionapp.bpweb.bp.com',
      SubscriptionKey: process.env.REACT_APP_API_SUBSCRIPTION_KEY!,
    },
  });

  const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
  });
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
